import { Panel, SubPanel } from '../enums';

export interface ActivePanel {
  panel: Panel;
  subPanel: SubPanel;
}
